import { render, staticRenderFns } from "./FeedbackGroupSelector.vue?vue&type=template&id=4b55918f&scoped=true&"
import script from "./FeedbackGroupSelector.vue?vue&type=script&lang=js&"
export * from "./FeedbackGroupSelector.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackGroupSelector.vue?vue&type=style&index=0&id=4b55918f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55918f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VHover,VIcon,VRow,VSkeletonLoader,VTooltip})
